import {cn} from '@containers/html-utils'
import React from 'react'
import tw from 'tailwind-styled-components'
import {TextInput} from './text-input'
import {AutoGrowingInputProps} from './types'

const TwContainer = tw.div`
  relative
  h-24
`

const TwSpanContainer = tw.div`
  whitespace-nowrap
  overflow-hidden
`

export const AutoGrowingInput = (props: AutoGrowingInputProps) => {
  const spanRef = React.useRef<HTMLSpanElement>()

  const onKeyUp = (e: React.KeyboardEvent<HTMLInputElement>) => {
    const target = e.target as HTMLInputElement
    spanRef.current.innerHTML = target?.value
  }

  const minWidth = !props.value && props.minWidth
  const maxWidth = props.maxWidth

  const spanClassName = cn(minWidth, maxWidth, props.spanClassName)
  const inputClassNameLocal = 'absolute w-full left-0 top-0'
  const inputClassName = cn(inputClassNameLocal, maxWidth, props.inputClassName)

  return (
    <TwContainer>
      <TwSpanContainer ref={spanRef} className={spanClassName}>
        {props.value}
      </TwSpanContainer>
      <TextInput
        {...props}
        onKeyUp={onKeyUp}
        className={inputClassName}
        inputContainerStyle={props.inputContainerStyle}
      />
    </TwContainer>
  )
}
